/**
 * Application Route Constants
 * Centralized routing configuration for easy maintenance
 */

export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  CAREERS: '/careers',
  TECHNOLOGY_ECOSYSTEM: '/technology-ecosystem',
  WHY_MS_TECHNOLOGIES: '/why-ms-technologies',
  LEADERSHIP: '/leadership',
  INDUSTRIES: '/industries',
  INSIGHTS: '/insights',
  INSIGHTS_DETAIL: '/insights/:slug',
  SOLUTIONS: '/solutions',
  SAP_SOLUTIONS: '/solutions/sap-transformation',
  AI_SOLUTIONS: '/solutions/ai-databricks',
  BLOCKCHAIN_SOLUTIONS: '/solutions/blockchain-web3',
};

/**
 * Navigation helper functions
 */
export const getInsightDetailPath = (slug) => {
  return `/insights/${slug}`;
};

export const isDetailPage = (pathname) => {
  return pathname.startsWith('/insights/') && pathname !== '/insights';
};
